// All DB timestamps come back as MySQL DATETIME strings ("YYYY-MM-DD HH:MM:SS.SSS")
// stored in UTC. Render them in Asia/Kolkata so operators read times in the
// timezone they actually live in.

const IST = 'Asia/Kolkata';

function toDate(ts) {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  // Already ISO with timezone: trust it.
  if (typeof ts === 'string' && /[zZ]$|[+\-]\d{2}:?\d{2}$/.test(ts)) {
    const d = new Date(ts); return isNaN(d) ? null : d;
  }
  // Bare "YYYY-MM-DD HH:MM:SS[.SSS]" → treat as UTC.
  if (typeof ts === 'string') {
    const d = new Date(ts.replace(' ', 'T') + 'Z');
    return isNaN(d) ? null : d;
  }
  return null;
}

export function fmtIST(ts) {
  const d = toDate(ts); if (!d) return '';
  return d.toLocaleString('en-IN', {
    timeZone: IST, day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
}

export function fmtISTShort(ts) {
  const d = toDate(ts); if (!d) return '';
  return d.toLocaleString('en-IN', {
    timeZone: IST, day: '2-digit', month: 'short',
    hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

export function fmtISTTime(ts) {
  const d = toDate(ts); if (!d) return '';
  return d.toLocaleString('en-IN', {
    timeZone: IST, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
}

export function fmtISTDate(ts) {
  const d = toDate(ts); if (!d) return '';
  return d.toLocaleString('en-IN', {
    timeZone: IST, day: '2-digit', month: 'short', year: 'numeric',
  });
}
